import { PublicKey } from '@solana/web3.js'

export default {
    data() {
        return {
            rpc: process.env.MIX_SOLANA_RPC
        }
    },
    computed: {
        isDevnet() {
            return this.rpc.indexOf('devnet') !== -1
        },
        devnet() {
            return this.isDevnet ? '?cluster=devnet' : ''
        }
    },
    methods: {
        lamportsToSol(value, fixed = 9) {
            return parseFloat(Number(value / 1000000000).toFixed(fixed))
        },
        isValidSolanaAddress(address) {
            try {
                const publicKey = new PublicKey(address)
                return PublicKey.isOnCurve(publicKey.toBytes())
            } catch (error) {
                return false;
            }
        },
        getOrdinalSuffix(number) {
            if (typeof number !== 'number' || isNaN(number)) {
                return "-";
            }

            const lastDigit = number % 10;
            const lastTwoDigits = number % 100;

            if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
                return number + "th";
            } else {
                switch (lastDigit) {
                    case 1:
                    return number + "st";
                    case 2:
                    return number + "nd";
                    case 3:
                    return number + "rd";
                    default:
                    return number + "th";
                }
            }
        },
        fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
        },
        copyToClipboard(text) {
            if (!navigator.clipboard) {
                this.fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function() {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }
}
